import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FurnishedEquip } from '../../../../shared/model';
import { ToolTypeDescriptionService, ToolDescriptionByTypeService, ToolTypeService } from '../../camtl.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';



@Component({
  selector: 'app-furnished-equipment',
  templateUrl: './furnished-equipment.component.html',
  // styleUrls: ['./furnished-equipment.component.scss']
})
export class FurnishedEquipmentComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private ToolTypeDescriptionService: ToolTypeDescriptionService,
    private ToolDescriptionByTypeService: ToolDescriptionByTypeService,
    // private FurnishedService: FurnishedService,
    private ToolTypeService: ToolTypeService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,

  ) { }
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  isNew: boolean = false;
  FurnishedEquipDescription: any;
  editDataItem: FurnishedEquip;
  ToolTypeId: any;


  editForm = this.formBuilder.group({
    Id: [],
    Name: ["", Validators.required],
    Description: ["", Validators.required],
    ToolTypeId: ["", Validators.required],
    CreatedDate: [],
    CreatedBy: [],
    IsActive: [false, Validators.required],
    ModifiedDate: [],
    ModifiedBy: [],
    AdditionalInfo: [],
  })



  columns: any[] = [
    {
      field: "Name",
      title: "Name",
    },

    {
      field: "Description",
      title: "Description",
    },
    // {
    //   field: "ToolTypeId",
    //   title: "ToolTypeId",
    // },
    // {
    //   field: 'ToolTypeId',
    //   title: 'Tool Type',
    //   template: {
    //     type: 'filter',
    //     filter: {
    //       field: "Description",
    //       check: "Id",
    //       readonly: "never",
    //     },
    //     pipe: 'nameById',
    //     dataSource: this.ToolTypeService,
    //   }
    // },
    {
      field: "IsActive",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
    {
      field: "AdditionalInfo",
      title: "Additional Info",

    }
  ]


  handleread = () => {

    var self = this;

    return this.ToolTypeService.read("", true).then(function (toolTypes: any) {
      self.ToolTypeId = toolTypes.filter(function (ToolType) {
        return ToolType.Description.toUpperCase() === "FURNISHED EQUIPMENT";
      })[0].Id;

      return self.ToolDescriptionByTypeService.read("/" + self.ToolTypeId + "/tooldescription", true).then(function (response: any[]) {

        return response;


      })
    })
  }

  onEdit(object) {

  }

  // onSave = (toolTypes, isNew) => {
  //   var self = this;

  //   if (this.ToolTypeId.Description === "Furnished Equipment") {
  //     // toolTypes = toolTypes.ToolDetail;
  //     this.ToolTypeDescriptionService.save(toolTypes, isNew, "Detail", false, false).then(function () {
  //       // self.setCounts();
  //       // self.grid.refresh(true);
  //       self.cgpSnackbarService.showSnackbar({
  //         message: "Record has been updated",
  //         duration: 2000
  //       })
  //     })
  //   }
  //   else {
  //     this.ToolTypeDescriptionService.save(toolTypes, isNew, "", false, false).then(function () {
  //       // self.setCounts();
  //       // self.grid.refresh(true);
  //       self.cgpSnackbarService.showSnackbar({
  //         message: "Record has been updated",
  //         duration: 2000
  //       })
  //     })
  //   }
  // }

  onSave = (dataItem, isNew) => {
    var self = this;
    self.ToolTypeDescriptionService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.ToolTypeDescriptionService.loading.next(false);
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.ToolTypeDescriptionService.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }


  template = {

    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: false,
      width: 65,
    },
    columns: this.columns,
    service: this.ToolTypeDescriptionService,
    read: this.handleread,
    save: this.onSave,
  }

  formDialog = {
    title: "Furnished Equipment",
    formControls: [
      {
        type: "text",
        name: "Name",
        title: "Name",
        readonly: "never",

      },
      {
        type: "text",
        name: "Description",
        title: "Description",
      },
      // {
      //   type: "combobox",
      //   name: "ToolTypeId",
      //   title: "Tool Type Id",
      //   textField: 'ToolTypeId',
      //   valueField: 'ToolTypeId',
      //   placeholder: 'Select a ToolTypeId...',
      //   service: this.ToolTypeDescriptionService,

      // },

      {
        type: "boolean",
        name: "IsActive",
        title: "Active",
        readonly: "never",
      },
      {
        type: "text",
        name: "AdditionalInfo",
        title: "Additional Info",
      }
    ],
  }


  public ngOnInit(): void {
    this.ToolTypeDescriptionService.query();
    this.ToolTypeService.query();


    //  this.ParameterManagementTypeService.ToolType$.subscribe() 
  }

  // handleValue() {
  //   if (this.ToolTypeDescriptionService.read("/" + "3", true)
  //     console.log("Found")

  //   else console.log("Not Found")
  // };


  setModelHandler() {
    this.editDataItem = new FurnishedEquip();
    this.editDataItem.ToolTypeId = this.ToolTypeId;
    this.editDataItem.IsActive = false;
  }

}